__turbopack_context__.v({
  "buttonGroup": "modal-module-scss-module__frHt4q__buttonGroup",
  "closeIcon": "modal-module-scss-module__frHt4q__closeIcon",
  "closeIconContainer": "modal-module-scss-module__frHt4q__closeIconContainer",
  "closeIconSolo": "modal-module-scss-module__frHt4q__closeIconSolo",
  "containedButtonGroup": "modal-module-scss-module__frHt4q__containedButtonGroup",
  "contentContainer": "modal-module-scss-module__frHt4q__contentContainer",
  "disableHover": "modal-module-scss-module__frHt4q__disableHover",
  "extraPadding": "modal-module-scss-module__frHt4q__extraPadding",
  "isFixedWidth": "modal-module-scss-module__frHt4q__isFixedWidth",
  "modalContainer": "modal-module-scss-module__frHt4q__modalContainer",
  "modalSecondaryButton": "modal-module-scss-module__frHt4q__modalSecondaryButton",
  "storyModalContainer": "modal-module-scss-module__frHt4q__storyModalContainer",
  "tertiaryButton": "modal-module-scss-module__frHt4q__tertiaryButton",
  "threeButtons": "modal-module-scss-module__frHt4q__threeButtons",
  "u-animation-bounce": "modal-module-scss-module__frHt4q__u-animation-bounce",
});
